/* Refine the complete Shopify collection; never only the visible page. */
(() => {
  const select = document.querySelector('[data-catalog-refine]');
  if (select) select.addEventListener('change', () => {
    const url = new URL(location.href);
    // Replace this quick selection while retaining unrelated detailed filters and sorting.
    for (const option of select.options) if (option.dataset.param) {
      const values = url.searchParams.getAll(option.dataset.param).filter(value => value !== option.value);
      url.searchParams.delete(option.dataset.param);
      values.forEach(value => url.searchParams.append(option.dataset.param, value));
    }
    const option = select.selectedOptions[0];
    if (option.dataset.param) url.searchParams.append(option.dataset.param, option.value);
    url.searchParams.delete('page');
    location.assign(url.href);
  });
  const sidebar = document.querySelector('.nr-catalog-page .nr-category-tree');
  const currentPath = location.pathname.replace(/\/$/, '');
  sidebar?.querySelectorAll('a[href]').forEach(link => {
    if (new URL(link.href, location.origin).pathname.replace(/\/$/, '') === currentPath) {
      link.setAttribute('aria-current', 'page');
    }
  });
  document.querySelectorAll('.nr-catalog-page .nr-category-group').forEach((group, index) => {
    group.open = index === 0;
  });
  document.querySelectorAll('.nr-catalog-page .nereli-catalog-filters, .nr-catalog-page .nereli-filter-group').forEach(group => {
    group.open = false;
  });
})();
